import { configureStore } from '@reduxjs/toolkit';
import { YamatReducer } from './YamatReducer';

export default configureStore({
  reducer: YamatReducer,
});
